import { Flex, Input, Text } from '@chakra-ui/react';
import { useState } from 'react';

export interface EditTitleProperties {
  title: string;
  setTitle?: (title: string) => void;
  placeholder?: string;
  onTitleChange?: (title: string) => void;
  showLabel?: boolean;
}
const EditTitle = ({
  title,
  setTitle,
  onTitleChange,
  placeholder = '',
  showLabel = true,
}: EditTitleProperties) => {
  const [newTitle, setNewTitle] = useState(title);

  const handleChange = (event: any) => {
    setNewTitle(event);
    if (onTitleChange) {
      onTitleChange(event);
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && setTitle) {
      setTitle(newTitle);
    }
  };

  const handleBlur = () => {
    if (setTitle) setTitle(newTitle);
  };

  return (
    <Flex flexDir={'column'} gap='4px'>
      {showLabel && (
        <Text fontFamily='Roboto Bold' fontWeight='600' fontSize='11px' color='#708090'>
          Title
        </Text>
      )}

      <Input
        placeholder={placeholder || 'Name here'}
        color='#121826'
        _placeholder={{ color: '#708090' }}
        px='11px'
        py='11px'
        h='auto'
        borderRadius='9px'
        fontWeight={400}
        fontSize='13px'
        fontFamily='Roboto Regular'
        autoFocus
        border='1px solid #D9D9D9'
        background='white'
        _focus={{ borderColor: '#8B5CF6', boxShadow: 'none' }}
        value={newTitle}
        onChange={(event) => handleChange(event.target.value)}
        onKeyPress={handleKeyPress}
        onBlur={handleBlur}
      />
    </Flex>
  );
};

export default EditTitle;
